(() => {
	"use strict";
	var __webpack_modules__ = {
			200: (__unused_webpack_module, exports) => {
				var LoadType, MatchType;
				Object.defineProperty(exports, "__esModule", {
						value: !0
					}), exports.evalScript = exports.Optimizer = exports.appBaseUrl = exports.localStorageKey = exports.lazyscriptAppended = exports.MatchType = exports.LoadType = void 0,
					function(e) {
						e.OnLoad = "OnLoad", e.FirstInteraction = "FirstInteraction", e.DomContentLoaded = "DomContentLoaded", e.Immediately = "Immediately", e.Never = "Never"
					}(LoadType || (exports.LoadType = LoadType = {})),
					function(e) {
						e.DOM = "DOM", e.DynamicInsert = "DynamicInsert"
					}(MatchType || (exports.MatchType = MatchType = {})), exports.lazyscriptAppended = "lazyscript-appended", exports.localStorageKey = "lazyscript-data", exports.appBaseUrl = "https://localhost:7120";
				class Optimizer {
					get loadType() {
						return this._loadType
					}
					get matchType() {
						return this._matchType
					}
					loadOn(e) {
						return this._loadType = e, this
					}
					matchOn(e) {
						return this._matchType = e, this
					}
					constructor(e) {
						this._matchedNodes = [], this._isOff = !1, this._loadType = LoadType.OnLoad, this._isOff = e
					}
					matchesScript(e) {
						var t, i, n, o;
						let s = !1;
						return(e.src && (null === (t = this._matchOptions) || void 0 === t ? void 0 : t.src) && e.src.includes(this._matchOptions.src) || e.textContent && (null === (i = this._matchOptions) || void 0 === i ? void 0 : i.contentPart) && e.textContent.includes(this._matchOptions.contentPart) || e.type && (null === (n = this._matchOptions) || void 0 === n ? void 0 : n.type) && e.type === this._matchOptions.type || (null === (o = this._matchOptions) || void 0 === o ? void 0 : o.queryMatch) && e.matches(this._matchOptions.queryMatch)) && (s = !0), s && !this._matchedNodes.find((t => t.originalElement === e))
					}
					matchesCss(e) {
						var t, i, n;
						let o = !1;
						return(e.href && (null === (t = this._matchOptions) || void 0 === t ? void 0 : t.href) && e.href.includes(this._matchOptions.href) || e.rel && (null === (i = this._matchOptions) || void 0 === i ? void 0 : i.rel) && e.rel === this._matchOptions.rel || (null === (n = this._matchOptions) || void 0 === n ? void 0 : n.queryMatch) && e.matches(this._matchOptions.queryMatch)) && (o = !0), o && !this._matchedNodes.find((t => t.originalElement === e))
					}
					matchesIFrame(e) {
						var t, i;
						let n = !1;
						return(e.src && (null === (t = this._matchOptions) || void 0 === t ? void 0 : t.src) && e.src.includes(this._matchOptions.src) || (null === (i = this._matchOptions) || void 0 === i ? void 0 : i.queryMatch) && e.matches(this._matchOptions.queryMatch)) && (n = !0), n && !this._matchedNodes.find((t => t.originalElement === e))
					}
					matchesImage(e) {
						var t, i, n;
						let o = !1;
						return(e.src && (null === (t = this._matchOptions) || void 0 === t ? void 0 : t.src) && e.src.includes(this._matchOptions.src) || e.dataset.src && (null === (i = this._matchOptions) || void 0 === i ? void 0 : i.src) && e.dataset.src.includes(this._matchOptions.src) || (null === (n = this._matchOptions) || void 0 === n ? void 0 : n.queryMatch) && e.matches(this._matchOptions.queryMatch)) && (o = !0), o && !this._matchedNodes.find((t => t.originalElement === e))
					}
					handleMatch(e, t) {
						var i, n;
						const o = {
							parent: e.parentElement || document.head,
							originalElement: e,
							isAppended: !1
						};
						null == t || t(e, o), this.loadType !== LoadType.Never && (this._matchedNodes.push(o), (this.loadType === LoadType.Immediately || this._isOff) && (!document.body && "script" === (null === (i = e.nodeName) || void 0 === i ? void 0 : i.toLocaleLowerCase()) && e instanceof HTMLScriptElement && (null === (n = e.innerHTML) || void 0 === n ? void 0 : n.includes("document.body")) ? document.addEventListener("DOMContentLoaded", this.load.bind(this)) : this.load()))
					}
					append(e, t) {
						t.dataset.lazyscriptAppended = exports.lazyscriptAppended, this.loadType === LoadType.DomContentLoaded && null != document.body ? document.body.appendChild(t) : e.parent.appendChild(t)
					}
				}
				exports.Optimizer = Optimizer;
				const evalScript = scriptContent => {
					try {
						eval(scriptContent)
					} catch(e) {
						console.error(`An error occurred while executing delayed script:\n      Error:\n        ${e}\n      Script:\n        ${scriptContent}`)
					}
				};
				exports.evalScript = evalScript
			},
			930: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.IFrameOptimizer = void 0;
				const n = i(200);
				class o extends n.Optimizer {
					constructor(e, t) {
						super(t), this._matchOptions = e
					}
					tryMatch(e) {
						var t;
						if("iframe" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLIFrameElement) return !!this.matchesIFrame(e) && (e.setAttribute("data-lazyscript-src", e.getAttribute("src")), e.removeAttribute("src"), this.handleMatch(e), !0)
					}
					load() {
						for(const e of this._matchedNodes.filter((e => !e.isAppended))) e.originalElement.setAttribute("src", e.originalElement.getAttribute("data-lazyscript-src")), e.isAppended = !0
					}
				}
				t.IFrameOptimizer = o
			},
			649: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.ImageOptimizer = void 0;
				const n = i(200);
				class o extends n.Optimizer {
					constructor(e, t) {
						super(t), this._matchOptions = e
					}
					tryMatch(e) {
						var t;
						if("img" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLImageElement) return !!this.matchesImage(e) && (this.handleMatch(e, (e => {
							var t, i;
							e.dataset.src = null !== (t = e.dataset.src) && void 0 !== t ? t : e.src, e.dataset.srcset = null !== (i = e.dataset.srcset) && void 0 !== i ? i : e.srcset, e.removeAttribute("src"), e.removeAttribute("srcset")
						})), !0)
					}
					load() {
						for(const e of this._matchedNodes.filter((e => !e.isAppended))) e.isAppended = !0, e.originalElement.setAttribute("src", e.originalElement.dataset.src), e.originalElement.setAttribute("srcset", e.originalElement.dataset.srcset)
					}
				}
				t.ImageOptimizer = o
			},
			581: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.LazySequencedScriptOptimizer = void 0;
				const n = i(200);
				class o extends n.Optimizer {
					constructor(e, t) {
						super(t), this._matchPattern = e
					}
					tryMatch(e) {
						var t;
						if("script" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLScriptElement) {
							const t = e.src || e.textContent,
								i = this._matchPattern.replace("*", ""),
								n = e.type.toString().replace(i, "");
							return !(!e.type.includes(i) || !n || isNaN(Number(n)) || this._matchedNodes.find((e => e.src === t)) || (e.type = "delayed-script", this.handleMatch(e, ((e, i) => {
								i.src = t, i.type = e.src ? "src" : "eval", i.order = Number(n)
							})), 0))
						}
					}
					load() {
						this.loadSequenced(this._matchedNodes, Math.min(...this._matchedNodes.map((e => e.order)), 0))
					}
					loadSequenced(e, t) {
						const i = e.filter((e => e.order === t));
						if(!e.filter((e => e.order === t - 1)).some((e => !e.isAppended)) && !e.every((e => e.isAppended))) {
							for(const n of i)
								if("src" === n.type) {
									const i = document.createElement("script");
									i.src = n.src;
									const o = () => {
										n.isAppended = !0, this.loadSequenced(e, t + 1)
									};
									i.onload = o, i.onerror = o, this.append(n, i)
								} else {
									const e = document.createElement("script");
									e.innerHTML = n.originalElement.innerHTML, this.append(n, e), n.isAppended = !0
								}
							this.loadSequenced(e, t + 1)
						}
					}
				}
				t.LazySequencedScriptOptimizer = o
			},
			513: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.LinkOptimizer = void 0;
				const n = i(200);
				class o extends n.Optimizer {
					constructor(e, t) {
						super(t), this._matchOptions = e
					}
					tryMatch(e) {
						var t;
						if("link" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLLinkElement) return !!this.matchesCss(e) && (e.rel = "delayed-css", this.handleMatch(e), !0)
					}
					load() {
						for(const e of this._matchedNodes.filter((e => !e.isAppended))) {
							e.isAppended = !0;
							const t = document.createElement("link");
							t.href = e.originalElement.href, t.rel = "stylesheet", this.append(e, t)
						}
					}
				}
				t.LinkOptimizer = o
			},
			412: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.ScriptOptimizer = void 0;
				const n = i(200);
				class o extends n.Optimizer {
					constructor(e, t) {
						super(t), this._matchOptions = e
					}
					tryMatch(e) {
						var t;
						if("script" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLScriptElement) {
							const t = e.src || e.textContent;
							return !!this.matchesScript(e) && (e.type = "delayed-script", this.handleMatch(e, ((i, n) => {
								n.src = t, n.type = e.src ? "src" : "eval"
							})), !0)
						}
					}
					load() {
						for(const e of this._matchedNodes.filter((e => !e.isAppended)))
							if(e.isAppended = !0, "src" === e.type) {
								const t = document.createElement("script");
								t.src = e.src, this.append(e, t)
							} else {
								e.isAppended = !0;
								const t = document.createElement("script");
								t.innerHTML = e.originalElement.innerHTML, t.className = e.originalElement.className, this.append(e, t)
							}
					}
				}
				t.ScriptOptimizer = o
			},
			794: (e, t, i) => {
				Object.defineProperty(t, "__esModule", {
					value: !0
				}), t.lazyscriptOptimizer = void 0;
				const n = i(200),
					o = i(930),
					s = i(649),
					a = i(581),
					r = i(513),
					d = i(412);
				t.lazyscriptOptimizer = class {
					constructor(e, t) {
						var i, o, s;
						this._delayedDefinitions = [], this._domDefinitions = null, this._dynamicDefinitions = null, this._eventListeners = {}, this._loadedListeners = [], this._isOff = !1, this._appendedCss = [], this.mutationCallback = (e, t) => {
							e.forEach((e => {
								"childList" === e.type && e.addedNodes.forEach((e => {
									var t, i;
									if("body" === (null === (t = e.nodeName) || void 0 === t ? void 0 : t.toLocaleLowerCase()) && e instanceof HTMLBodyElement) this.overrideBodyAppendFunctions(e);
									else if(e instanceof HTMLElement && (null === (i = null == e ? void 0 : e.dataset) || void 0 === i ? void 0 : i.lazyscriptAppended) != n.lazyscriptAppended)
										for(const t of this.getDomDefinitions())
											if(t.tryMatch(e)) break
								}))
							}))
						}, this._observer = new MutationObserver(this.mutationCallback), this._isOff = e, ((null === (i = null === window || void 0 === window ? void 0 : window.Shopify) || void 0 === i ? void 0 : i.designMode) || "unpublished" === (null === (s = null === (o = null === window || void 0 === window ? void 0 : window.Shopify) || void 0 === o ? void 0 : o.theme) || void 0 === s ? void 0 : s.role))
					}
					observeDocument() {
						this._observer.observe(document, {
							childList: !0,
							subtree: !0
						}), this.overrideHeadAppendFunctions(document.head), document.addEventListener("DOMContentLoaded", this.onDomContentLoaded.bind(this)), "complete" === document.readyState ? this.onLoad(void 0) : window.addEventListener("load", this.onLoad.bind(this))
					}
					delayScript(e) {
						const t = new d.ScriptOptimizer(e, this._isOff);
						return this._delayedDefinitions.push(t), t
					}
					delayLink(e) {
						const t = new r.LinkOptimizer(e, this._isOff);
						return this._delayedDefinitions.push(t), t
					}
					lazyLoadSequencedScripts(e) {
						const t = new a.LazySequencedScriptOptimizer(e, this._isOff);
						return this._delayedDefinitions.push(t), t
					}
					delayIframe(e) {
						const t = new o.IFrameOptimizer(e, this._isOff);
						return this._delayedDefinitions.push(t), t
					}
					optimizeImage(e) {
						const t = new s.ImageOptimizer(e, this._isOff);
						return this._delayedDefinitions.push(t), t
					}
					appendCss(e, t) {
						if(this._isOff) return;
						const i = document.createElement("style");
						i.setAttribute("type", "text/css"), i.appendChild(document.createTextNode(e)), document.head.appendChild(i), this._appendedCss.push({
							element: i,
							removeOn: t
						})
					}
					appendHtml(e) {
						this._isOff || document.write(e)
					}
					getCustomerId() {
						return this.getCookie("_shopify_y")
					}
					shouldBeOff() {
						return Math.random() < .05
					}
					getShop() {
						var e;
						return null === (e = null === window || void 0 === window ? void 0 : window.Shopify) || void 0 === e ? void 0 : e.shop
					}
					getCartToken() {
						return this.getCookie("cart")
					}
					getCookie(e) {
						let t = document.cookie.split(";");
						for(let i = 0; i < t.length; i++) {
							let n = t[i].trim();
							if(n.startsWith(e + "=")) return n.substring(e.length + 1)
						}
						return "null"
					}
					getDomDefinitions() {
						var e;
						return null === this._domDefinitions && (this._domDefinitions = null !== (e = this._delayedDefinitions.filter((e => e.matchType == n.MatchType.DOM))) && void 0 !== e ? e : []), this._domDefinitions
					}
					getDynamicDefinitions() {
						var e;
						return null === this._dynamicDefinitions && (this._dynamicDefinitions = null !== (e = this._delayedDefinitions.filter((e => e.matchType == n.MatchType.DynamicInsert))) && void 0 !== e ? e : []), this._dynamicDefinitions
					}
					interceptLoadedEvents() {
						const e = document.addEventListener,
							t = (e, t) => {
								const i = "load" === e ? this._loadEventData : this._domContentLoadedEventData;
								this._loadedListeners.push({
									func: () => t.bind(this)(i),
									id: Math.random().toString(16).slice(2).toString()
								})
							},
							i = function(i, n, o) {
								"load" !== i && "DOMContentLoaded" !== i ? this ? (this.f = e, this.f(i, n, o)) : e.bind(this)(i, n, o) : t(i, n)
							};
						document.addEventListener = i, window.addEventListener = i
					}
					executeInterceptedEvents() {
						const e = [];
						this._loadedListeners.forEach((t => {
							t.func(), e.push(t.id)
						})), e.forEach((e => {
							const t = this._loadedListeners.findIndex((t => t.id === e));
							this._loadedListeners.splice(t, 1)
						}))
					}
					overrideBodyAppendFunctions(e) {
						const t = e.appendChild,
							i = this.getDynamicDefinitions();
						e.appendChild = o => {
							var s;
							if(o instanceof HTMLElement && (null === (s = null == o ? void 0 : o.dataset) || void 0 === s ? void 0 : s.lazyscriptAppended) != n.lazyscriptAppended) {
								for(const e of i)
									if(e.tryMatch(o)) break;
								return t.call(e, o)
							}
							return t.call(e, o)
						}
					}
					overrideHeadAppendFunctions(e) {
						const t = e.appendChild;
						e.appendChild = i => {
							var o;
							if(i instanceof HTMLElement && (null === (o = null == i ? void 0 : i.dataset) || void 0 === o ? void 0 : o.lazyscriptAppended) != n.lazyscriptAppended) {
								for(const e of this.getDynamicDefinitions()) e.tryMatch(i);
								return t.call(e, i)
							}
							return t.call(e, i)
						};
						const i = e.insertBefore;
						e.insertBefore = (t, o) => {
							var s;
							if(t instanceof HTMLElement && (null === (s = null == t ? void 0 : t.dataset) || void 0 === s ? void 0 : s.lazyscriptAppended) != n.lazyscriptAppended) {
								for(const e of this.getDynamicDefinitions()) e.tryMatch(t);
								return i.call(e, t, o)
							}
							return i.call(e, t, o)
						}
					}
					onDomContentLoaded(e) {
						this._domContentLoadedEventData = e, this._observer.disconnect();
						const t = this._delayedDefinitions.filter((e => e.loadType === n.LoadType.DomContentLoaded));
						for(const e of t) e.load();
						for(const e of this._appendedCss)
							if(e.removeOn === n.LoadType.DomContentLoaded) {
								e.element.remove();
								const t = this._appendedCss.findIndex((t => t === e));
								this._appendedCss.splice(t, 1)
							}
					}
					onLoad(e) {
						this._loadEventData = e, this.interceptLoadedEvents();
						const t = this._delayedDefinitions.filter((e => e.loadType === n.LoadType.OnLoad));
						for(const e of t) e.load();
						setTimeout((() => {
							this.executeInterceptedEvents(), requestAnimationFrame((() => this.attachFirstInteractionEventListeners()))
						}), 10)
					}
					onUserInteraction() {
						const e = this._delayedDefinitions.filter((e => e.loadType === n.LoadType.FirstInteraction));
						for(const t of e) t.load(), this.executeInterceptedEvents();
						setTimeout((() => {
							this.removeFirstInteractionEventListeners()
						}), 5e3)
					}
					attachFirstInteractionEventListeners() {
						this._eventListeners.mousemove = this.onUserInteraction.bind(this), this._eventListeners.scroll = this.onUserInteraction.bind(this), this._eventListeners.keydown = this.onUserInteraction.bind(this), this._eventListeners.click = this.onUserInteraction.bind(this), this._eventListeners.touchstart = this.onUserInteraction.bind(this);
						for(const e in this._eventListeners)
							if(Object.prototype.hasOwnProperty.call(this._eventListeners, e)) {
								const t = this._eventListeners[e];
								document.addEventListener(e, t)
							}
					}
					removeFirstInteractionEventListeners() {
						for(const e in this._eventListeners)
							if(Object.prototype.hasOwnProperty.call(this._eventListeners, e)) {
								const t = this._eventListeners[e];
								document.removeEventListener(e, t)
							}
					}
				}
			}
		},
		__webpack_module_cache__ = {};

	function __webpack_require__(e) {
		var t = __webpack_module_cache__[e];
		if(void 0 !== t) return t.exports;
		var i = __webpack_module_cache__[e] = {
			exports: {}
		};
		return __webpack_modules__[e](i, i.exports, __webpack_require__), i.exports
	}
	var __webpack_exports__ = {};
	(() => {
		const e = __webpack_require__(200),
			t = __webpack_require__(794);
		! function() {
			var i;
			if("undefined" == typeof MutationObserver || null === MutationObserver) return;
			const n = new t.lazyscriptOptimizer(null === (i = null === location || void 0 === location ? void 0 : location.search) || void 0 === i ? void 0 : i.includes("lazyscript=disable"));
			n.observeDocument(),
			n.delayScript({
				queryMatch: "#web-pixels-manager-setup"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction),
			n.delayScript({
				type: "lazyload-script"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.OnLoad),
			n.delayScript({
				type: "lazyload-script-fi"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				type: "lazyload-script-dcl"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.DomContentLoaded), n.delayLink({
				rel: "lazyload-script-fi"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "klaviyo.js?company_id=WYnxBK"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "window._klOnsite"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				queryMatch: ".analytics"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				queryMatch: ".boomerang"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "assets/storefront/features"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "assets/shopify_pay"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "connect.facebook.net"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "cdn.fodane.app"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				contentPart: "asyncLoad()"
			}).matchOn(e.MatchType.DOM).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				contentPart: "instant.min.js"
			}).matchOn(e.MatchType.DynamicInsert).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				contentPart: "fbevents.js"
			}).matchOn(e.MatchType.DynamicInsert).loadOn(e.LoadType.FirstInteraction), n.delayScript({
				src: "analytics.tiktok"
			}).matchOn(e.MatchType.DynamicInsert).loadOn(e.LoadType.FirstInteraction)
		}()
	})()
})();
//# sourceMappingURL=lazyload-scripts.js.map